<template>
  <div class="purchase-router">
    <keep-alive>
      <router-view class="purchase-page"></router-view>
    </keep-alive>
  </div>
</template>

<script>
export default {}
</script>

<style scoped lang="less">
.purchase-router {
  display: flex;
  flex-direction: column;
}
.purchase-page {
  flex: 1;
}
</style>